import { defineGameCard, ongoing } from '../authoring/index.js';
import { slimeDependencies, trail, } from './slime-helpers.js';
import { isLocationFilled } from './furniture_helpers.js';
export const ColonyPredatorCard = defineGameCard({
    id: 'colony_predator',
    gameplay: { type: 'UNIT', cost: 3, baseStats: { attack: 2, health: 2 }, traits: ['SLIME'] },
    presentation: {
        name: 'Колониальный хищник',
        description: 'След 1. Пока локация заполнена картами, получает +4 к атаке.',
        glyph: {
            colors: ['#10213A', '#74AD4C', '#96C653', '#5E984F', '#3A624D'],
            rows: [
                '....................',
                '........1111........',
                '......11223311......',
                '.....1433333341.....',
                '....143333333341....',
                '....133333333341....',
                '...12333333333241...',
                '...12231333312441...',
                '..1423333333324451..',
                '..1422333323224451..',
                '.14422222222224451..',
                '.144222222222444451.',
                '.144222222224444451.',
                '.144222222444444451.',
                '..14444444444444551.',
                '..1444444444444551..',
                '..1555444444455551..',
                '...11555555555511...',
                '.....1111111111.....',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: slimeDependencies(),
    abilities: [
        trail(),
        ongoing((ctx) => {
            const self = ctx.self;
            if (self?.cellId === undefined)
                return [];
            const active = isLocationFilled(ctx, self.cellId);
            return active
                ? [{
                        abilityId: 'colony_attack',
                        scope: { kind: 'unit', instanceId: self.id },
                        statMods: [{ stat: 'attack', op: 'add', value: 4 }],
                    }]
                : [];
        }),
    ],
    ui: { mechanics: ['trail', 'slime_residue'] },
});
//# sourceMappingURL=colony_predator.js.map